<script>
export default {
  name: 'MenuItemExternal',

  props: {
    item: {
      type: Object,
      required: true,
    },

    level: {
      type: Number,
      required: true,
    },
  },

  computed: {
    attributes() {
      return this.item.fields.openInNewTab === true ? { rel: 'noreferrer', target: '_blank' } : '';
    },
  },
};
</script>

<template>
  <a :class="`level-${level}`" :href="item.fields.link.fields.url" v-bind="attributes">
    {{ item.fields.heading }}
    <img class="icon" v-if="item.fields.openInNewTab" src="@/assets/svg-icons/external-link.svg" />
  </a>
</template>

<style lang="scss" scoped>
.level-0 {
  @include menu-item-level-0;
}

.level-1 {
  @include menu-item-level-1;
}

.level-2 {
  @include menu-item-level-2;
}
</style>
